import React from 'react'

import { DropOffType, TenantConfiguration, WasteType } from '../../domain/models'

export interface ISearchTerm {
  name: string
  fullName: string
}

export interface IConfigurationContext {
  tenantId?: string,
  wasteTypeList: Array<WasteType>
  setWasteTypeList: (values: Array<WasteType>) => void
  mostPopularSearches: Array<ISearchTerm>
  tenantConfiguration?: TenantConfiguration
  setTenantConfiguration: (value: TenantConfiguration) => void
  dropoffTypeList: Array<DropOffType>
}

export const ConfigurationContext = React.createContext<IConfigurationContext>({
  wasteTypeList: [],
  mostPopularSearches: [],
  setWasteTypeList: () => console.warn('setWasteTypeList not implemented in the current context'),
  setTenantConfiguration: () => console.warn('setTenantConfiguration not implemented in the current context'),
  dropoffTypeList: []
})


export const useConfigurationContext = (): IConfigurationContext => React.useContext(ConfigurationContext)
